import { identity } from 'ramda';
import { createContext } from '@cian/pik-booking-widget';
import {
  IPhoneConfirmationCodeRequestParams,
  IPhoneConfirmationCodeCheckRequestParamsTrue,
  IRequestBookingLinkParams,
} from '@cian/pik-booking-widget/lib/shared/models';
import { getHttpApi } from '@cian/http-api/browser';
import { getConfig } from '@cian/config/browser';
import { fetchBooking, TResponses as TBookingResponse } from '../../../shared/repositories/pik-booking/v1/booking';
import {
  fetchConfirmPhone,
  TResponses as TConfirmPhoneResponse,
} from '../../../shared/repositories/pik-booking/v1/confirm-phone';
import { fetchSendPhoneConfirmationCode } from '../../../shared/repositories/pik-booking/v1/send-phone-confirmation-code';

export function createBookingContext() {
  if (!getConfig().has('pikBookingApiBaseUrl')) {
    return undefined;
  }

  return createContext({
    sendPhoneConfirmationCode,
    sendPhoneConfirmationCodeCheck,
    requestBookingLink,
  });
}

export function sendPhoneConfirmationCode(parameters: IPhoneConfirmationCodeRequestParams) {
  return (fetchSendPhoneConfirmationCode({
    httpApi: getHttpApi(),
    parameters,
    config: { requestConfig: { withCredentials: true } },
    mappers: { 200: identity, 204: () => ({ statusCode: 204 }), 400: identity },
  }) as unknown) as Promise<void>;
}

export function sendPhoneConfirmationCodeCheck(parameters: IPhoneConfirmationCodeCheckRequestParamsTrue) {
  return fetchConfirmPhone({
    httpApi: getHttpApi(),
    parameters,
    mappers: { 200: identity, 400: identity },
  }) as Promise<TConfirmPhoneResponse>;
}

export function requestBookingLink(parameters: IRequestBookingLinkParams) {
  return fetchBooking({
    httpApi: getHttpApi(),
    parameters,
    mappers: { 200: identity, 400: identity },
  }) as Promise<TBookingResponse>;
}
